import type {Incoming} from '@pexip/infinity';
import {createSignal} from '@pexip/signal';

import type {
    Idp,
    RegistrationError,
    RegistrationStatus,
    RegistrationStep,
} from '../types';

export const openRegistrationModalSignal = createSignal({
    name: 'registration:open-modal',
});

export const registrationStatusSignal = createSignal<RegistrationStatus>({
    name: 'registration:status',
});

export const registrationStepSignal = createSignal<RegistrationStep>({
    name: 'registration:step',
});

export const registrationExpiredSignal = createSignal<boolean>({
    name: 'registration:expired',
});

export const registrationErrorSignal = createSignal<
    RegistrationError | undefined
>({
    name: 'registration:error',
});

export const registrationIncomingCallSignal = createSignal<
    Incoming | undefined
>({
    name: 'registration:incoming-call',
});

export const registrationIdpsSignal = createSignal<Idp[]>({
    name: 'registration:idps',
});

export const registrationMissedCallSignal = createSignal<Incoming>({
    name: 'registration:missed-call',
});
